import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectParticipantAttachment } from "../../utils/types/models";

export default createEntityReducer<IProjectParticipantAttachment>(Endpoint.ProjectParticipantAttachments, Endpoint.ProjectParticipantAttachmentsList);
